import { reviewsFilters } from './reviewsFilters.js';

function init() {
    reviewsFilters()
}

export {
    init   
}